import React, {useEffect} from 'react';
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom';
import './styles.css';
import './theme.css';
import './i18n';
import {useTranslation} from 'react-i18next';
import HomePage from './components/HomePage';
import BlogDetails from './components/BlogDetails';

function App() {
    const {i18n, t} = useTranslation();

    // Set dir + lang attributes and localized SEO title/description per language
    useEffect(() => {
        document.documentElement.dir = i18n.language === 'ar' ? 'rtl' : 'ltr';
        document.documentElement.lang = i18n.language;

        const title = t('page-title');
        if (title) document.title = title;

        const description = t('page-description');
        if (description) {
            const meta = document.querySelector('meta[name="description"]');
            if (meta) meta.setAttribute('content', description);
        }
    }, [i18n.language, t]);

    return (
        <Router>
            <div className="App">
                <Routes>
                    <Route path="/" element={<HomePage/>}/>
                    <Route path="/blog/:id" element={<BlogDetails/>}/>
                </Routes>
            </div>
        </Router>
    );
}

export default App;
